var map = {
	"./base-menu.svg": 2886,
	"./capacity-menu.svg": 576,
	"./dashboard-menu.svg": 9230,
	"./data-menu.svg": 4203,
	"./faq-menu.svg": 237,
	"./hidden-vin.svg": 4251,
	"./lang.svg": 8373,
	"./loading.svg": 9431,
	"./manage-menu.svg": 5546,
	"./mint-product.svg": 2456,
	"./offline-capacity.svg": 177,
	"./online-capacity.svg": 3493,
	"./processing-capacity.svg": 2116,
	"./quality-menu.svg": 3850,
	"./show-vin.svg": 838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7550;